export default [
    {
		path: "/formeditor/home",
		component: () => import("../views/FormEditor/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/formeditor/forms",
		component: () => import("../views/FormEditor/Forms.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/formeditor/form/:formid?",
		component: () => import("../views/FormEditor/Form.vue"),
	},
	{
		path: "/formeditor/formtypes",
		component: () => import("../views/FormEditor/FormTypes/List.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/formeditor/formtype/:formtypeid?",
		component: () => import("../views/FormEditor/FormTypes/Edit.vue"),
	},
	{
		path: "/formeditor/formschedules",
		component: () => import("../views/FormEditor/FormSchedules/List.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/formeditor/formschedule/:formscheduleid?",
		component: () => import("../views/FormEditor/FormSchedules/Edit.vue"),
	},
	{
		path: "/formeditor/formlibrary/:itemtype",
		component: () => import("../views/FormEditor/FormLibrary.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/formeditor/formlibraryitem/:itemid?",
		component: () => import("../views/FormEditor/FormLibraryItem.vue"),
	},
	{
		path: "/formeditor/questionbank",
		component: () => import("../views/FormEditor/QuestionBank/QuestionBank.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/formeditor/questionbankitem/:examquestionid?",
		component: () => import("../views/FormEditor/QuestionBank/QuestionBankItem.vue"),
	},
	{
		path: "/formeditor/responsevaluegroups",
		component: () => import("../views/FormEditor/ResponseValueGroups/ResponseValueGroups.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/formeditor/responsevaluegroupitem/:responsevaluegroupid?",
		component: () => import("../views/FormEditor/ResponseValueGroups/ResponseValueGroupItem.vue"),
	},
]
